<template>
  <div class="topbar">
    <!-- 添加国际化 -->
    <el-select class="lm-i18n" v-model="i18nValue" @change="i18nChange">
      <el-option v-for="item in langList" :key="item.value" :value="item.value" :label="item.local"></el-option>
    </el-select>

    <!-- <el-button class="top-item"> {{ $lang('面单库存') }}：{{ userInfo.stockCount || 0 }} </el-button> -->
    <el-dropdown>
      <span class="el-dropdown-link">
        <span class="user-avatar top-round-btn">
          <!-- <i class="iconfont icontouxiang"></i> -->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icontouxiang"></use>
          </svg>
        </span>
        <span class="name">{{ userInfo.account }}</span>
        <i class="el-icon-arrow-down"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="clickDownitem('1')">{{ $lang('我的资料') }}</el-dropdown-item>
        <el-dropdown-item @click.native="clickDownitem('2')">{{ $lang('退出登录') }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog
      :title="dialogTitle"
      custom-class="topBarDiadlog"
      :visible.sync="dialogFormVisible"
      width="1100px"
      @close="handleClose"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      top="100"
      :show-close="true"
    >
      <el-row>
        <el-col :span="4">
          <!-- <i class="icontouxiang iconfont information"></i> -->
          <svg class="icon information" aria-hidden="true">
            <use xlink:href="#icontouxiang"></use>
          </svg>
        </el-col>
        <el-col :span="20">
          <el-row>
            <el-col :span="8">
              <span>{{ $lang('用户名称') }}：</span><br/>
              <span class="form-item">{{ form.customerName }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('我的编码') }}：</span>
              <span class="form-item">{{ form.customerCode }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('绑定手机号') }}：</span>
              <span class="form-item">{{ form.contactMobile }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('账号类型') }}：</span>
              <span class="form-item">
                {{ form.type === 1 ? $lang('主账号') : $lang('子账号') }}
              </span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('账号状态') }}：</span>
              <span class="form-item">{{ form.status === 1 ? $lang('启用') : $lang('禁用') }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('当前主面单库存') }}：</span>
              <span class="form-item">{{ form.stockCount }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('当前子面单库存') }}：</span>
              <span class="form-item">{{ form.subStockNum }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('签约网点') }}：</span>
              <span class="form-item">{{ form.networkName }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ '\xa0\xa0\xa0\xa0' }}</span>
            </el-col>
            <el-col :span="8">
              <span>{{ $lang('调度收派员') }}：</span>
              <span class="form-item">{{ form.staffName }}</span>
            </el-col>
            <el-col :span="16">
              <span
                ><div class="switchSty">
                  <el-switch
                    :disabled="disableSwitch"
                    active-color="#31DAB3"
                    @change="changeSwitch($event)"
                    v-model="switchValue"
                  ></el-switch>
                  <span style="font-size: 10px;">{{ '\xa0\xa0\xa0\xa0' + $lang('当此开关打开时，表示需要收派员上门打印面单')}}</span>
                </div></span
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="modify-password-box" v-if="isModifyPassword">
        <el-form class="el-form-edit" ref="isAdd" :rules="rules" :inline="true" :model="resetPasswork" label-position="left" label-suffix=" :">
          <div class="modifyPasswork">
            <el-form-item :label="$lang('旧密码')" prop="oldPassword" class="modifyPassworkItem">
              <el-input v-model="resetPasswork.oldPassword" :placeholder="$lang('请输入旧密码')" show-password maxlength="18"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('新密码')" prop="newPassworkF" class="modifyPassworkItem">
              <el-input v-model="resetPasswork.newPassworkF" :placeholder="$lang('请输入新密码')" show-password maxlength="18"></el-input>
            </el-form-item>
            <el-form-item :label="$lang('确认新密码')" prop="newPassworkS" class="modifyPassworkItem">
              <el-input v-model="resetPasswork.newPassworkS" :placeholder="$lang('请输入新密码')" show-password maxlength="18"></el-input>
            </el-form-item>
          </div>
          <div style="text-align: center">
            <el-button type="primary" @click="goModifyPassword" size="big" plain="">{{ $lang('取消') }}</el-button>
            <el-button type="primary" @click="submit" size="big" style="margin-left: 20px">{{ $lang('确认修改') }}</el-button>
          </div>
        </el-form>
      </div>
      <div class="myAccount" v-if="!isModifyPassword">
        <div>
          <label>{{ $lang('登录账号') }}：</label>
          <el-input disabled v-model="form.account"></el-input>
          <el-button type="primary" class="h32 m24" plain @click="goModifyPassword">{{ $lang('修改密码') }}</el-button>
        </div>
      </div>
      <div class="myAccountPasswork">
        <div>
          <label>{{ $lang('面单格式') }}：</label>
          <el-select v-model="form.surfaceFormat" :placeholder="$lang('请选择')" :disabled="isPrintType">
            <el-option v-for="item in printTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
          <label class="m24">{{ $lang('默认打印机') }}：</label>
          <el-select v-model="form.targetPrinter" :placeholder="$lang('请选择')" :disabled="isPrintType">
            <el-option v-for="item in printNameList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
          <el-button type="primary" plain class="h32 m24" @click="isPrintType = !isPrintType" v-show="isPrintType">{{ $lang('修改面单格式') }}</el-button>
          <el-button type="primary" plain class="h32 m24" v-show="!isPrintType" size="big" @click="savePrint">{{ $lang('保存') }}</el-button>
        </div>
        <!-- <div>
                  <label>隐私面单：</label>
                   <el-select v-model="isPrivacy" placeholder="请选择" :disabled="isPrivacyTap">
                        <el-option
                            v-for="(item,index) in isPrivacyList"
                            :key="index"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                     <el-button type="primary" plain class="h32 m24" @click="isPrivacyTap = !isPrivacyTap" v-show="isPrivacyTap">修改</el-button>
                    <el-button type="primary" plain class="h32 m24" v-show="!isPrivacyTap" size="big"  @click="savePrivacy">保存</el-button>
                    <el-tooltip effect="dark" placement="bottom" style="margin-left:10px">
                        <span class="tooltip-click">? </span>
                         <div slot="content">
                            1.下单时，请填写真实有效的手机或固话。（暂不支持400电话）<br>
                            2.若隐私服务调用失败，则会使用普通面单样式打印<br>
                        </div>
                    </el-tooltip>
             </div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as Api from '@api/base/public'
import { RESPONSE_SUCCESS } from '@constants'
import { RULES } from '@utils/rules'
import { UserDetail, setNeedDispatch } from '@api/module/customer'

export default {
  name: 'Topbar',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value !== this.resetPasswork.newPassworkF) {
        callback(new Error(this.$lang('两次密码输入不一致!')))
      } else {
        callback()
      }
    }
    return {
      name: 'admin',
      showform: true,
      dialogTitle: this.$lang('我的资料'),
      show: false,
      disableSwitch: true,
      isPrintType: true,
      dialogFormVisible: false,
      isModifyPassword: false, // 是否修改密码
      isPrivacyTap: true, // 隐私面单
      printTypeList: [
        {
          value: 1,
          label: this.$lang('不默认面单格式'),
        },
        {
          value: 2,
          label: this.$lang('一联面单'),
        },
        // {
        //   value: 3,
        //   label: this.$lang('二联面单'),
        // },
      ],
      isPrivacyList: [
        {
          value: 1,
          label: this.$lang('是'),
        },
        { value: 0, label: this.$lang('否') },
      ],
      isPrivacy: 0, // 是否隐私面单 0:否 1:是
      switchValue: false,
      switchFlag: undefined,
      printNameList: [],
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        account: '',
        contactMobile: '',
        surfaceFormat: 1,
        targetPrinter: '',
      },
      resetPasswork: {
        oldPassword: '',
        newPassworkF: '',
        newPassworkS: '',
      },
      formLabelWidth: '120px',
      rules: {
        oldPassword: [RULES.required, RULES.checkPassword],
        newPassworkF: [RULES.required, RULES.checkPassword],
        newPassworkS: [RULES.required, RULES.checkPassword, { validator: validatePass, trigger: 'blur' }],
      },
      i18nValue: '',
    }
  },
  computed: {
    // 用户信息
    userInfo() {
      return this.$store.state.base.user || {}
    },
    isUpdateStock() {
      return this.$store.state.base.isUpdateStock || false
    },
    // 国际化语言
    lang() {
      return this.$store.state.base.lang
    },
    // 国际化列表
    langList() {
      return this.$store.state.base.langList
    },
  },
  watch: {
    async isUpdateStock(value) {
      if (value) {
        try {
          const { code, data } = await UserDetail({ id: this.userInfo.id })
          if (code === 1) {
            this.form.stockCount = data.stockCount || 0
            this.form.networkName = data.networkName || '--'
            this.form.staffName = data.staffName || '--'
            this.form.staffCode = data.staffCode
            this.form.needDispatch = data.needDispatch
            this.form.subStockNum = data.subStockNum || 0
            this.SET_USER({ ...this.userInfo, ...data }) // 更新vuex的用户数据
            this.UPDATE_PRINT_STOCK(false)
            if (data.staffCode) {
              this.disableSwitch = false
            } else {
              this.disableSwitch = true
            }
          }
        } catch (error) {
          this.UPDATE_PRINT_STOCK(false)
        }
      }
    },
    lang: {
      handler(val, oldVal) {
        this.i18nValue = val
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    ...mapActions(['LOGIN_OUT', 'SET_USER', 'UPDATE_PRINT_STOCK', 'SET_LANG']),
    // 语言切换
    i18nChange(lang) {
      this.SET_LANG(lang)
    },
    checkIsInstall() {
      try {
        this.printNameList = []
        this.LODOP = this.$getLodop()
        this.hasLodop = !!this.LODOP.VERSION
        const printCount = this.LODOP.GET_PRINTER_COUNT()
        // 获取所有打印机的名称
        for (let i = 0; i < printCount; i++) {
          this.printNameList.push(this.LODOP.GET_PRINTER_NAME(i))
        }
      } catch (err) {
        console.log('print:' + err)
      }
    },
    slideDowm() {
      this.show = !this.show
    },
    clickDownitem(index) {
      this.show = true
      switch (index) {
        case '1':
          this.Go()
          break
        case '2':
          this.Logout()
          break
      }
    },
    async Go() {
      this.checkIsInstall()
      this.dialogFormVisible = true
      this.form.account = this.userInfo.account
      this.form.customerCode = this.userInfo.customerCode
      this.form.type = this.userInfo.type
      this.form.targetPrinter = this.userInfo.targetPrinter
      // this.form.status = this.userInfo.status
      // this.form.customerName = this.userInfo.customerName || '--'
      // this.form.contactMobile = this.userInfo.contactMobile || '--'
      const { code, msg, data } = await UserDetail({ id: this.userInfo.id })
      if (code !== 1) {
        this.$message.error(this.$lang(msg))
        return
      }
      if (data.staffCode) {
        this.disableSwitch = false
      } else {
        this.disableSwitch = true
      }
      this.form.stockCount = data.stockCount || 0
      this.form.subStockNum = data.subStockNum || 0
      this.form.networkName = data.networkName || '--'
      this.form.staffName = data.staffName || '--'
      this.form.staffCode = data.staffCode
      this.form.surfaceFormat = data.surfaceFormat || 1
      this.form.customerName = data.customerName || '--'
      this.form.contactMobile = data.contactMobile || '--'
      this.form.needDispatch = data.needDispatch
      this.switchValue = data.needDispatch === 1
      this.form.status = data.status
      this.isPrivacy = data.isPrivacy || 0
      this.SET_USER({ ...this.userInfo, ...data }) // 更新vuex的用户数据
      //   this.clickOut()
    },
    // 开关切换
    async changeSwitch(switchVal) {
      if (switchVal === true) {
        this.switchValue = true
      } else {
        this.switchValue = false
      }
      const switchNum = (switchVal ? 1 : 2)
      console.log(switchNum)
      const pam = { 'needDispatchFlag': switchNum }
      const res = await setNeedDispatch(pam)
      if (res.code !== 1) {
        this.$message.error(this.$lang(res.msg))
        return
      } else {
        this.$message.success(this.$lang(res.msg))
        return
      }
    },
    handleClose() {
      this.showform = true
      this.resetPasswork.oldPassword = ''
      this.resetPasswork.newPassworkF = ''
      this.resetPasswork.newPassworkS = ''
      this.isPrintType = true
      this.$nextTick(function () {
        if (this.$refs['isAdd']) {
          this.$refs['isAdd'].resetFields()
        }
      })
    },
    Logout() {
      this.LOGIN_OUT().then(() => {
        // this.$common.setCookie('account', '')
        // this.$common.setCookie('pwd', '')
        this.$router.push({ name: 'login' })
      }) // 触发vuex的退出,
    },
    // goModifyPassword() {
    //   this.showform = !this.showform
    //   this.show = false
    //   this.dialogTitle = '修改密码'
    // },
    /*
     * 修改密码
     */
    goModifyPassword() {
      this.isModifyPassword = !this.isModifyPassword
    },
    goBack() {
      this.showform = !this.showform
      this.show = false
      this.dialogTitle = this.$lang('我的资料')
      this.$nextTick(function () {
        if (this.$refs['isAdd']) {
          this.$refs['isAdd'].resetFields()
        }
      })
    },
    changePasswordCb() {
      this.$confirm(this.$lang('密码修改成功'), this.$lang('提示'), {
        confirmButtonText: this.$lang('确定'),
        closeOnClickModal: false,
        showCancelButton: false,
        type: 'success',
        confirmButtonClass: 'comfirm-btn',
        iconClass: 'el-icon-warning-outline',
      })
        .then(() => {
          this.LOGIN_OUT().then(() => {
            this.$router.push({ name: 'login' })
          })
        })
        .catch((_) => {
          this.LOGIN_OUT().then(() => {
            this.$router.push({ name: 'login' })
          })
        })
    },
    async savePrint() {
      const params = {
        surfaceFormat: this.form.surfaceFormat,
        targetPrinter: this.form.targetPrinter,
      }
      try {
        const res = await Api.savePrintSetup(params)
        if (res.code === RESPONSE_SUCCESS) {
          const user = { ...this.userInfo, ...params }
          this.SET_USER(user) // 更新vuex的用户数据
          this.isPrintType = true
          this.$message.success(this.$lang('保存成功'))
        } else {
          this.$message.error(res.msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async submit() {
      this.$refs['isAdd'].validate(async (valid) => {
        if (valid) {
          const params = {
            oldPwd: this.$Base64.encode(this.resetPasswork.oldPassword + 'jadada236t2'),
            pwd: this.$Base64.encode(this.resetPasswork.newPassworkF + 'jadada236t2'),
          }
          const res = await Api.CHANGE_PASSWORD(params)
          if (res.code === RESPONSE_SUCCESS) {
            this.dialogFormVisible = false
            this.changePasswordCb()
          } else {
            this.$message.error(res.msg)
          }
        } else {
          return false
        }
      })
    },
    /**
     * @description 保存隐私面单
     */
    async savePrivacy() {
      const params = {
        isPrivacy: this.isPrivacy,
      }
      const res = await Api.savePrivacy(params)
      if (res.code === RESPONSE_SUCCESS) {
        this.isPrivacyTap = true
        this.$message.success(this.$lang('保存成功'))
      } else {
        this.$message.error(res.msg)
      }
    },
  },
}
</script>
<style lang="scss" rel="text/css">
$iconSize: 20px;
$themeBorder: 3px;
$top-btn-width: 24px;
.m24 {
  margin-left: 24px;
}
.topbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #000;
  height: 100%;
  position: relative;
  line-height: 48px;
  transition: all 0.2s linear;
  .lm-i18n {
    // position: absolute;
    // right: 10px;
    // top: 10px;
    width: 90px;
    margin-right: 10px;
    .el-input {
      width: 100% !important;
    }
    .el-input__inner {
      padding: 0 15px !important;
      border-radius: 10px !important;
      border: 1px solid #999 !important;
      height: 32px !important;
      line-height: 32px !important;
    }
    .el-input__inner::placeholder,
    .el-input__inner::-webkit-input-placeholder {
      color: #fff;
    }
  }
  .top-item {
    color: #666666;
    margin-right: 16px;
    line-height: 5px;
    font-weight: 400;
    // width: 120px;
    height: 24px;
    background: #edeef3;
    border-radius: 12px;
    cursor: default;
    &:hover {
      border-color: #ddd;
    }
  }
  .el-dropdown-link {
    display: flex;
    cursor: pointer;
  }
  .top-round-btn {
    margin-right: 8px;
    .icon {
      position: relative;
      top: 5px;
      font-size: 24px;
    }
  }
  .name {
    max-width: 98px;
    line-height: 48px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    margin-right: 16px;
  }
  i {
    line-height: 48px;
  }
  .information {
    font-size: 80px;
    top: 10px;
    position: relative;
  }
  .down-pover {
    position: absolute;
    right: 0;
    top: 48px;
    width: calc(100% - 190px);
    z-index: 100;
    background: inherit;
    margin: 0;
    list-style: none;
    padding-left: 20px;
    padding-bottom: 10px;
    min-width: 100px;
    li {
      line-height: 30px;
      font-size: 14px;
      cursor: pointer;
      opacity: 0.6;
      &:hover {
        opacity: 1;
        color: #e0bd7b;
      }
    }
  }
  .tooltip-click {
    background: red;
    cursor: pointer;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
    -webkit-text-fill-color: #fff;
  }
  .el-dialog {
    .el-dialog__body {
      padding: 30px 48px;
    }
    .el-dialog__header {
      border-bottom: 1px solid #eeeeee;
      .el-dialog__headerbtn {
        top: 0px;
      }
    }
    .el-dialog__footer {
      border-top: 1px solid #eeeeee;
    }
    .myDetail {
      display: inline-flex;
      padding-bottom: 24px;
      .myDetailInfo {
        margin-top: -25px;
        .item-row {
          display: inline-flex;
        }
      }
      .myAvatar {
        width: 90px;
        height: 90px;
        line-height: 145px;
        background: rgb(102, 102, 102);
        color: rgb(216, 216, 216);
        border-radius: 90px;
        margin-right: 24px;
        i {
          font-size: 90px;
        }
      }
      .myDetailItem {
        width: 170px;
        font-size: 14px;
        line-height: 18px;
        .myDetailItemText {
          color: #999999;
          padding-bottom: 8px;
          padding-top: 25px;
        }
      }
    }
    .modify-password-box {
      background: #eee;
      border-radius: 8px;
      padding: 24px;
    }
    .myAccount {
      margin-top: 36px;
    }
    // .myAccountPasswork{
    // margin-top: 12px;
    // }
  }
}
.el-dropdown-menu {
  .el-dropdown-menu__item {
    padding: 0 40px 0 20px !important;
    list-style: none;
    line-height: 36px;
    padding: 0 20px;
    margin: 0;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    outline: none;
  }
}
.el-dropdown-link:hover {
  .name {
    color: $--color-primary;
  }
}
.topbar .topBarDiadlog {
  .el-dialog__header {
    span {
      font-size: 24px !important;
      font-weight: 700 !important;
    }
  }
  .el-col-8 {
    color: #999999;
    display: flex;
  }
  .form-item {
    color: #333;
    font-weight: 700;
    text-overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
    // overflow: hidden;
    width: 50px;
    white-space: nowrap;
    .switchSty {
      text-align: center;
    }
  }
}
</style>

